import script from "./leftPie3.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie3.vue?vue&type=script&setup=true&lang=js"

import "./leftPie3.vue?vue&type=style&index=0&id=b4d6f5f2&scoped=true&lang=css"
script.__scopeId = "data-v-b4d6f5f2"

export default script